import { Subject } from 'rxjs';
import { style } from '@angular/animations';

export class AppHelper {
  static reSize: Subject<any> = new Subject();

  static pushResize() {
    AppHelper.reSize.next({});
  }

  static calcListHeight() {
    console.log();

    setTimeout(() => {
      let deletedSpaces = 0;
      const header = document.getElementById('header');
      const tableOptions = document.getElementById('tableOptions');
      const pagination = document.getElementById('pagination');
      const tableActions = document.getElementById('table-multi-actions');
      const reportTable = document.getElementsByClassName('filter-section');
      let reportTableHeight = 100;
      if (header) {
        deletedSpaces += header.offsetHeight;
      }
      if (pagination) {
        deletedSpaces += pagination.offsetHeight;
      }
      if (tableOptions) {
        deletedSpaces += tableOptions.offsetHeight;
      }
      if (tableActions) {
        deletedSpaces += tableActions.offsetHeight;
      }
      if (reportTable && reportTable[0]) {
        document.documentElement.style.setProperty('--reportTableHeight', 200 + 'px');
      }
      // console.log(deletedSpaces);

      const listHeight = window.innerHeight - deletedSpaces - 35;
      // const mapHeight = window.innerHeight - (header ? header.offsetHeight : 0);
      document.documentElement.style.setProperty('--allHeight', window.innerHeight + 'px');
      document.documentElement.style.setProperty('--listHeight', listHeight + 'px');
      // document.documentElement.style.setProperty('--mapHeight', mapHeight + 'px');
    }, 0);
  }

  /**
   * this method retrieve value from deep object
   * @param obj => whole object
   * @param path => path to value
   */
  static deepFind(obj: {}, path: string) {
    const paths = path.split('.');
    let current: any = obj;
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < paths.length; ++i) {
      if (current[paths[i]] === null) {
        return '';
      } else {
        current = current[paths[i]];
      }
    }
    return current;
  }

  /* To copy any Text */
  static copyToClipboard(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  static calcMainContainerWidth() {
    const windowWidth = window.innerWidth;
    document.documentElement.style.setProperty('--window-width', windowWidth + 'px');

    const menuWidth = document.querySelector('.main-menu').clientWidth;
    document.documentElement.style.setProperty('--main-menu-width', menuWidth + 'px');

    const mainContainerWidth = windowWidth - menuWidth;
    document.documentElement.style.setProperty('--main-container-width', mainContainerWidth + 'px');

    // const listTable = document.querySelector('.list-grid-container').clientWidth ;
    // console.log(document.getElementsByClassName('.list-grid-container'));
    // document.documentElement.style.setProperty('--list-table-width', mainContainerWidth + 'px');
    // document.getElementsByClassName('list-grid-container')[0].setAttribute('style',mainContainerWidth - 60 +'px');
    // console.log('calcMainContainerWidth', windowWidth, menuWidth, mainContainerWidth);
  }

  static checkWindowResize() {
    let resizeId: any;
    window.addEventListener('resize', () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(() => {
        this.doneResizing();
      }, 500);
    });
  }

  static doneResizing() {
    this.calcMainContainerWidth();
  }

  static arrayLast(array: []) {
    return array[array.length - 1];
  }

  constructor() {}
}
